<template>
  <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%">
    <div class="el-table__body-wrapper is-scrolling-none">
      <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
        <colgroup>
          <col width="180" />
          <col />
        </colgroup>
        <tbody>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>发票抬头</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">{{ invoice.taxTitle }}</div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>税号</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">{{ invoice.taxNo }}</div>
            </td>
          </tr>
          <tr class="el-table__row">
            <td rowspan="1" colspan="1">
              <div class="cell">
                <strong>申请时间</strong>
              </div>
            </td>
            <td rowspan="1" colspan="1">
              <div class="cell">{{ invoice.createdDate }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="el-table__column-resize-proxy" style="display: none"></div>
  </div>

  <el-divider></el-divider>

  <el-form style="margin: 0 10px" ref="form" :model="form" label-width="120px">
    <el-form-item label="备注" prop="memo" :rules="{ required: true, message: '请输入备注' }">
      <el-input type="textarea" :rows="5" v-model="form.memo" placeholder="快递名称：顺丰 快递单号：99999999999"></el-input>
    </el-form-item>
  </el-form>

  <el-divider></el-divider>

  <div class="el-dialog__footer">
    <el-button type="primary" @click="btnSubmitClick">确 定</el-button>
    <el-button @click="btnCancelClick">取 消</el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { IInvoice } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/invoices';

interface IForm {
  memo: string;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    invoice: {
      type: Object as PropType<IInvoice>,
      required: true,
    },
  },
  data() {
    return {
      form: {
        memo: this.invoice.memo,
      },
    } as IState;
  },
  methods: {
    apiSubmit() {
      api.delivery(
        {
          invoiceId: this.invoice.id,
          memo: this.form.memo,
        },
        (res) => {
          if (!res.value) return;

          utils.success('发票开具操作成功！');
          this.$emit('submit');
        },
      );
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    invoice(value) {
      this.form.memo = value.memo;
    },
  },
});
</script>
